import type { AvailableFiltersItemProps } from '@services/api/preview/types'

export const getInitialMultiFilterValue = (options: AvailableFiltersItemProps[]): string[] => {
  if (!options || options.length === 0) return []

  const todosOption = options.find((item) => {
    const isTodosByCode = item.code === 'all' || item.code?.toLowerCase() === 'all'
    const isTodosByName = item.name?.toLowerCase() === 'todos' || item.name === 'Todos'
    return isTodosByCode || isTodosByName
  })

  const optionsWithoutTodos = options.filter((item) => {
    const isTodosByCode = item.code === 'all' || item.code.toLowerCase() === 'all'
    const isTodosByName = item.name?.toLowerCase() === 'todos' || item.name === 'Todos'
    return !isTodosByCode && !isTodosByName
  })

  if (optionsWithoutTodos.length === 1) return [optionsWithoutTodos[0].code]

  // Listas sem "Todos" vindo do back ganham um "Todos" local (toOptions) — o valor inicial é ele
  return todosOption ? [todosOption.code] : optionsWithoutTodos.length > 1 ? ['all'] : []
}
